const UPLOAD_ATTACHMENT_TO_CHANNEL_REQUEST = 'UPLOAD_ATTACHMENT_TO_CHANNEL_REQUEST';
const UPLOAD_ATTACHMENT_TO_CHANNEL_SUCCESS = 'UPLOAD_ATTACHMENT_TO_CHANNEL_SUCCESS';
const UPLOAD_ATTACHMENT_TO_CHANNEL_FAILURE = 'UPLOAD_ATTACHMENT_TO_CHANNEL_FAILURE';
const CHANNEL_RECEIVED_NEW_MESSAGE = 'CHANNEL_RECEIVED_NEW_MESSAGE';
const SELECT_CHANNEL = 'SELECT_CHANNEL';
const RESTORE_UNREAD_MESSAGE_COUNT = 'RESTORE_UNREAD_MESSAGE_COUNT';
const MANAGER_MESSAGES_OVERVIEW_REQUEST = 'MANAGER_MESSAGES_OVERVIEW_REQUEST';
const MANAGER_MESSAGES_OVERVIEW_SUCCESS = 'MANAGER_MESSAGES_OVERVIEW_SUCCESS';
const MANAGER_MESSAGES_OVERVIEW_FAILURE = 'MANAGER_MESSAGES_OVERVIEW_FAILURE';

export default {
  UPLOAD_ATTACHMENT_TO_CHANNEL_REQUEST,
  UPLOAD_ATTACHMENT_TO_CHANNEL_SUCCESS,
  UPLOAD_ATTACHMENT_TO_CHANNEL_FAILURE,
  CHANNEL_RECEIVED_NEW_MESSAGE,
  SELECT_CHANNEL,
  RESTORE_UNREAD_MESSAGE_COUNT,
  MANAGER_MESSAGES_OVERVIEW_REQUEST,
  MANAGER_MESSAGES_OVERVIEW_SUCCESS,
  MANAGER_MESSAGES_OVERVIEW_FAILURE
};
